<template>
    <div v-if="show">
      <hp5-alert type="info" hide-alert-text :show-alert="true">
        <div>
          <span class="bold">Chiropractic care</span> See any Chiropractic provider. No need to be in-network for these services.
          <a href="/my/home/site/my-plan/benefits">Check my UnityPoint Health plan</a>
        </div>
      </hp5-alert>
    </div>
</template>
  
<script setup>

      const codes = ['psp40', 'lsp69']
      const { profile, specialties } = useFCPModel()
      const hasCoverage = computed(() => profile.value.hasAnyUnityPointCoverage)
  
      const containsCode = (codes, specialties) => {
        for (let i = 0; i < codes.length; i++) {
          const code = codes[i]
          const sp = specialties?.value?.find((s) => s.id == code)
          if (sp) return true
        }
        return false
      }
  
      const codeMatch = computed(() => containsCode(codes, specialties.value))
      const show = computed(() => hasCoverage.value && codeMatch.value)

</script>
<style scoped>
  .bold {
    font-weight: bold;
  }
</style>